// 需要搜索的列
const filterList = ["ExtNum", "PONum", "DtStart", "DtEnd", "AmName", "AmUserName", "DspName", "DspUserName", "Qty", "Kilometre", "SettleAmount"]

// 列的基本信息
const columns = [{
	"title": "客户会议编号",
	"dataIndex": "ExtNum",
	"key": "ExtNum",
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "ExtNum"
	}
}, {
	"title": "中智会议编号",
	"dataIndex": "PONum",
	"key": "PONum",
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "PONum"
	}
}, {
	"title": "会议开始日期",
	"dataIndex": "DtStart",
	"key": "DtStart",
	"sorter": true,
	"width": 160,
	"align": "center",
	"scopedSlots": {
		"customRender": "DtStart"
	}
}, {
	"title": "会议结束日期",
	"dataIndex": "DtEnd",
	"key": "DtEnd",
	"sorter": true,
	"width": 160,
	"align": "center",
	"scopedSlots": {
		"customRender": "DtEnd"
	}
}, {
	"title": "会议申请人",
	"dataIndex": "AmName",
	"key": "AmName",
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "AmName"
	}
}, {
	"title": "申请人工号",
	"dataIndex": "AmUserName",
	"key": "AmUserName",
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "AmUserName"
	}
}, {
	"title": "会议负责人",
	"dataIndex": "DspName",
	"key": "DspName",
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "DspName"
	}
}, {
	"title": "负责人工号",
	"dataIndex": "DspUserName",
	"key": "DspUserName",
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "DspUserName"
	}
}, {
	"title": "订单量",
	"dataIndex": "Qty",
	"key": "Qty",
	"sorter": true,
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "Qty"
	}
}, {
	"title": "公里数",
	"dataIndex": "Kilometre",
	"key": "Kilometre",
	"sorter": true,
	"width": 140,
	"align": "center",
	"scopedSlots": {
		"customRender": "Kilometre"
	}
}, {
	"title": "总金额",
	"dataIndex": "SettleAmount",
	"key": "SettleAmount",
	"sorter": true,
	"align": "center",
	"scopedSlots": {
		"customRender": "SettleAmount"
	}
}, {
	"title": "操作",
	"dataIndex": "action",
	"align": "center",
	"scopedSlots": {
		"customRender": "action"
	},
	"width": 100,
	"fixed": "right"
}]

export {
	filterList,
	columns
}
